import { App, createApp } from 'vue'
import { Pinia, storeToRefs } from 'pinia'
import { useUiStore } from '~/store/ui'
import SentryConfig from '~/types/SentryConfig'

import useSentry from '~/composables/useSentry'
import components from '~/components'

interface AppConfig {
  mountName?: string,
  CONFIG?: {
    SENTRY?: SentryConfig,
  }
  FLAGS?: {
    withSentry?: boolean
  }
}

/**
 * A factory for Vue app instances to mount into the DOM
 *
 * Intended to be used with the Hydrater's Strategy pattern
 */
const useApp = (pinia: Pinia, appConfig: AppConfig): App<Element> => {
  const { CONFIG, FLAGS, mountName } = appConfig

  const app = createApp({
    name: mountName ?? 'App',
    setup() {
      const uiStore = useUiStore()
      const { openNavDropdown } = storeToRefs(uiStore)

      return {
        openNavDropdown,
      }
    },
  })

  app.use(pinia)

  if (FLAGS?.withSentry && CONFIG?.SENTRY?.ENABLED) {
    useSentry(CONFIG.SENTRY, app)
  }

  components.forEach((Component) => {
    app.component(Component.name, Component)
  })

  return app
}

export default useApp
